import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  component: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor:
      window.sessionStorage.getItem('appState') === 'superUser'
        ? theme.colors.primaryLight
        : window.sessionStorage.getItem('appState') === 'timeMachine'
        ? theme.colors.background.primaryLight
        : theme.colors.white,
    padding: '0 5px',
    minHeight: '44px',
    maxHeight: '44px',
    marginLeft: '5px',
    borderBottom: `1px solid ${theme.colors.darkGray}`,
  },
  headline: {
    fontWeight: 'bold',
    padding: 5,
  },
  icons: {
    fontSize: '20px',
    color: theme.colors.primary,
    transition: '0.3s',
  },
  buttonDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    type: 'button',
    cursor: 'pointer',
    marginLeft: 4,
    padding: '2px 10px',
    ':hover': {
      backgroundColor: theme.colors.gray,
    },
    borderRadius: 9,
  },
  buttonDivActive: {
    backgroundColor: theme.colors.primaryLight,
  },
  selectMenu: {
    width: '90px',
    height: 'fit-content',
    alignSelf: 'center',
    backgroundColor: theme.colors.gray,
    marginRight: '25px',
  },
  whiteHeader: {
    color: 'white',
  },
});
